export default `
  <div class="wb-doc-page">
    <div class="doc-main-title">一、积分收益</div>
    <div class="doc-text doc-pb28">用户所获得的积分，系统每天按用户个人新增积分在社区所占比例，根据奖池方式派发现金奖励。</div>
    <div class="doc-text doc-pb28">用户当天发文及互动所获得的积分统计为当天积分收益，系统按用户当天新增积分在整个社区的贡献比例，根据奖池方式派发相应比例现金奖励。</div>
    <div class="doc-text doc-pb28">互动包括：阅读、点赞/被点赞、评论/被评论、回复/被回复、分享/被分享。（发文及分享一天最多计3篇为有效收益积分，评论、点赞不限）</div>
    <div class="doc-text doc-pb28">积分收益：派发为每天0点后，系统自动统计前一天社区新增积分总数据，并根据用户个人当天新增积分贡献比例派发现金奖励至用户收益账号。</div>

    <div class="doc-main-title">二、收益提现</div>
    <div class="doc-text doc-pb28">用户可在【我的-社区收益】查看奖励并申请提现，收益账号累积满200港元以上可提现，提现只支持转为人民币提现，每周三统一进行提现审核，汇款周期一般为7个工作日内处理完成，节假日顺延。</div>
  </div>
`
